import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollableContainer } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { useCallback } from 'react';
import { MediaService } from '../../../services/media/MediaService';
import { BottomCenter, Popup, TopCenter } from '../../../utils/popups';
import { DeviceSelector, DeviceSelectorContainer, DeviceSelectorPopupRoot, } from './DeviceSelectorPopup';
export const CameraSelectorPopup = ({ reject, resolve, variant, ...props }) => {
    const mediaService = MediaService.getNotificationInterface();
    const videoDevices = MediaService.getOutput().useVideoDevices();
    const selectedDevice = MediaService.getOutput().useSelectedVideoDevice();
    const isEnabled = MediaService.getOutput().useVideoMuted();
    const hasPermission = MediaService.getOutput().useCameraPermissioned();
    const onDeviceSelect = useCallback((device) => {
        mediaService.notifyVideoDeviceSelected(device);
        resolve();
    }, [mediaService, resolve]);
    const onAllowAccess = useCallback(() => {
        mediaService.notifyMediaPermissionsRequested({ video: true });
        resolve();
    }, [mediaService, resolve]);
    const onEnableChange = useCallback((enabled) => {
        mediaService.notifyVideoMutingChangeRequested(!enabled);
    }, [mediaService]);
    const translateFn = variant === 'top-center' ? TopCenter : BottomCenter;
    return (_jsx(DeviceSelectorPopupRoot, { className: variant, reject: reject, translateFn: translateFn, ...props, children: _jsx(ScrollableContainer, { children: _jsx(DeviceSelectorContainer, { children: _jsx(DeviceSelector, { label: "Camera", devicesList: videoDevices, selectedDevice: selectedDevice, onDeviceSelect: onDeviceSelect, isEnabled: !isEnabled, onEnableChange: onEnableChange, onClose: reject, hasAccessToDevices: hasPermission, onAllowAccess: onAllowAccess }) }) }) }));
};
const cameraPopup = Popup.create(CameraSelectorPopup);
export function selectCamera(options) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await cameraPopup.pop({
                anchorRef: options.anchorRef,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
